
export enum AiChatType {
    CHAT            = 1,
    WRITE_WITH_AI   = 2,
}

export enum AIChatContextType {
    ALL_SPACES  = 'all-spaces',
    PROJECT     = 'project',
    TASK        = 'task',
}

export enum AIChatProvider {
    GPT_4                   = 'gpt-4o',
    GPT_4o_MINI             = 'gpt-4o-mini',
    // GPT_5                   = 'gpt-5',
    // GPT_5_NANO              = 'gpt-5-nano',
    //
    // GEMINI_2_5_FLASH        = 'gemini-2.5-flash',
    // GEMINI_2_5_FLASH_PRO    = 'gemini-2.5-flash-pro',
    // GEMINI_2_5_FLASH_LITE   = 'gemini-2.5-flash-lite',
}

export enum AiChatParticipant {
    USER    = 1,
    BACKEND = 2,
    AI      = 3
}

export enum AiChatMessageType {
    QUERY                   = "query",                  // user first message
    ANSWER                  = "answer",                 // ai answered to users
    ERROR                   = "error",                  // ai could not process request

    TOOLS_CALL_REQUEST      = "tools_call_request",
    TOOLS_CALL_RESPONSE     = "tools_call_response",

    CONTEXT                 = "context",
    COMPACTION              = "compaction",
    TOOLS_SELECTION         = "tools_selection",
    STRING_TO_VECTOR        = "string_to_vector",
    CHAT_NAME               = "chat_name",
    BACKEND_AI_TURNS_EXITED = "backend_ai_turns_exited"

}


export const InputPricing: Record<AIChatProvider, number> = {
    [AIChatProvider.GPT_4o_MINI]    : 0.15,
    [AIChatProvider.GPT_4]          : 0.15,
}

export const CachedPricing: Record<AIChatProvider, number> = {
    [AIChatProvider.GPT_4o_MINI]    : 0.075,
    [AIChatProvider.GPT_4]          : 1.25,
}

export const OutputPricing: Record<AIChatProvider, number> = {
    [AIChatProvider.GPT_4o_MINI]: 0.60,
    [AIChatProvider.GPT_4]: 10.00,
}
